var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 as uuidv4 } from "uuid";
import { IdResolver } from "./index";
export default class UuidIdResolver extends IdResolver {
    static typeName() {
        return "UuidResolver";
    }
    static isCompatibleWith(type) {
        return [this.typeName(), "PureUuidResolver"].indexOf(type) !== -1;
    }
    // eslint-disable-next-line class-methods-use-this
    gen() {
        return __awaiter(this, void 0, void 0, function* () {
            return uuidv4();
        });
    }
    // eslint-disable-next-line class-methods-use-this
    close() {
        return Object.getPrototypeOf(this).constructor.typeName();
    }
}
//# sourceMappingURL=uuid.idResolver.js.map